var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6667 70.5V83C91.6714 84.1604 91.4337 85.309 90.9688 86.3722C90.5039 87.4355 89.8221 88.3899 88.967 89.1744C88.1119 89.9589 87.1024 90.5561 86.0031 90.9279C84.9038 91.2997 83.7391 91.4377 82.5833 91.3333C69.7618 89.9401 57.4458 85.5589 46.625 78.5416C36.5576 72.1444 28.0222 63.609 21.625 53.5416C14.5832 42.6716 10.201 30.2958 8.83333 17.4166C8.72921 16.2644 8.86615 15.1031 9.23542 14.0067C9.60469 12.9103 10.1982 11.9028 10.9782 11.0484C11.7582 10.1939 12.7075 9.51125 13.7658 9.0438C14.8241 8.57635 15.9681 8.33438 17.125 8.33329H29.625C31.6471 8.31339 33.6075 9.02945 35.1407 10.348C36.6739 11.6666 37.6753 13.4977 37.9583 15.5C38.4859 19.5002 39.4644 23.428 40.875 27.2083C41.4356 28.6996 41.5569 30.3204 41.2246 31.8786C40.8923 33.4368 40.1203 34.8671 39 36L33.7083 41.2916C39.6398 51.7231 48.2769 60.3601 58.7083 66.2916L64 61C65.1329 59.8797 66.5631 59.1077 68.1213 58.7753C69.6795 58.443 71.3003 58.5644 72.7917 59.125C76.572 60.5356 80.4997 61.514 84.5 62.0416C86.524 62.3272 88.3725 63.3466 89.6939 64.9062C91.0153 66.4657 91.7174 68.4565 91.6667 70.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.87d84d05387a02b4033352617bcc426d.svg";
export { ForwardRef as ReactComponent };